function lockUnderwearItems() {
  const cartRows = document.querySelectorAll('.cart-main tr');

  cartRows.forEach((row) => {
    const hasUnderwearLink = row.querySelector(
      'a[href*="/products/womens-seamless-underwear"]'
    );

    if (hasUnderwearLink) {

      const buttons = row.querySelectorAll('button');
      buttons.forEach((button) => {
        button.style.display = 'none';
      });

      const inputs = row.querySelectorAll('input');
      inputs.forEach((input) => {
        input.readOnly = true;  
      });

      row.style.opacity = '0.8';
    }
  });
}

lockUnderwearItems();

const observer = new MutationObserver(lockUnderwearItems);
observer.observe(document.body, {
  childList: true,
  subtree: true
});